import {
  GET_ADMINS_SUCCESS,
  GET_ADMINS_FAIL,
  GET_ADMIN_PROFILE_SUCCESS,
  GET_ADMIN_PROFILE_FAIL,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_FAIL,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAIL,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAIL,
  DELETE_ADMIN,
  ADD_NEW_ADMIN,
  UPDATE_ADMIN
  
} from "./actionTypes";

const INIT_STATE = {
  admins: [],
  adminProfile: {},
  error: {},
  loading:true
};

const admins = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_ADMINS_SUCCESS:
      return {
        ...state,
        admins: action.payload.data,
        total_page:action.payload.total_page,
        loading: false,
      }

    case GET_ADMINS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
      case ADD_NEW_ADMIN:
        return {
          ...state,
          loading:true
        }
    case ADD_ADMIN_SUCCESS:
      return {
        ...state,
        admins: [...state.admins, action.payload],
        loading:false
      }

    case ADD_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_ADMIN:
        return {
          ...state,
          loading:true
        }
    case UPDATE_ADMIN_SUCCESS:
      {
        // console.log(action.payload)
         return {
        ...state,
        admins: state.admins.map(admin =>
          admin.id.toString() === action.payload.id.toString()
            ? { ...admin, ...action.payload }
            : admin
        ),
        loading:false
      }
      }
     

    case UPDATE_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_ADMIN:
      return {
        ...state,
        loading:true
      }
    case DELETE_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.filter(
          admin => admin.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ADMIN_PROFILE_SUCCESS:
      return {
        ...state,
        adminProfile: action.payload,
      }

    case GET_ADMIN_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default admins;
